export const SADE_SATI_HI_HEADLINE = "Sade Sati ka live phase check karein";
export const SADE_SATI_PAGE_HEADLINE =
  "Sade Sati: Why These 7.5 Years Feel So Heavy — Check Your Phase & Upay";
